import React from "react"

export default function DownloadCsv() {
  return (
    <svg viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg">
      <symbol viewBox="0 0 29 29" id="svg-download-csv">
        <path id="svg_1" fill="none" d="m14.5,25.916l0,-9.408" />
        <path
          id="svg_2"
          d="m14.544,17.816c0.39,0.033 0.706,0.345 0.739,0.739c0.059,2.119 0.059,4.24 0,6.359c-0.067,0.789 -1.485,0.961 -1.566,0a114.25,114.25 0 0 1 0,-6.359c0.036,-0.426 0.297,-0.754 0.827,-0.739z"
        />
        <path
          id="svg_3"
          d="m14.166,28.67a0.373,0.373 0 0 0 0.669,0l2.761,-5.523a0.374,0.374 0 0 0 -0.334,-0.542l-5.524,0a0.373,0.373 0 0 0 -0.334,0.542l2.762,5.523z"
        />
        <g id="svg_4">
          <path
            id="svg_6"
            d="m8.228,4.749c-1.656,0 -3.877,-0.557 -3.919,0.752c-0.048,4.574 -0.184,9.154 0.002,13.725c0.028,0.491 0.785,0.679 0.785,0.679l7.313,0l0,1.568c-2.559,0 -5.107,0.224 -7.678,-0.018c-1.104,-0.125 -1.961,-1.068 -1.99,-2.273a746.45,746.45 0 0 1 0,-13.715c0.022,-0.67 0.295,-1.332 0.836,-1.738c0.706,-0.529 2.036,-0.548 2.036,-0.548l2.615,0l0,1.568zm11.066,-4.703a1.826,1.826 0 0 1 1.738,1.738c0.027,1.72 0.446,3.743 -0.559,4.63c-1.056,0.932 -3.018,0.288 -3.097,-1.314c-0.037,-2.335 -0.514,-5.093 1.918,-5.054zm-0.129,1.567c-0.081,0.004 -0.196,-0.096 -0.22,0.187c-0.053,1.081 -0.019,2.166 -0.002,3.249c0.011,0.218 0.488,0.405 0.52,0.035c0.053,-1.081 0.019,-2.166 0.001,-3.249c-0.004,-0.093 0.068,-0.227 -0.299,-0.222z"
          />
          <path
            id="svg_7"
            d="m9.886,0.046a1.831,1.831 0 0 1 1.738,1.738c0.027,1.72 0.446,3.743 -0.558,4.63c-1.057,0.932 -3.019,0.288 -3.098,-1.314c-0.037,-2.335 -0.514,-5.093 1.918,-5.054zm-0.129,1.567c-0.081,0.004 -0.196,-0.093 -0.22,0.187c-0.053,1.081 -0.019,2.166 -0.001,3.249c0.01,0.218 0.488,0.405 0.519,0.035c0.053,-1.081 0.019,-2.166 0.002,-3.249c-0.005,-0.093 0.067,-0.227 -0.3,-0.222z"
          />
          <path
            id="svg_8"
            d="m8.228,4.749c-1.656,0 -3.877,-0.557 -3.919,0.752c-0.048,4.574 -0.184,9.154 0.002,13.725c0.028,0.491 0.785,0.679 0.785,0.679l7.313,0l0,1.568c-2.559,0 -5.107,0.224 -7.678,-0.018c-1.104,-0.125 -1.961,-1.068 -1.99,-2.273a746.45,746.45 0 0 1 0,-13.715c0.022,-0.67 0.295,-1.332 0.836,-1.738c0.706,-0.529 2.036,-0.548 2.036,-0.548l2.615,0l0,1.568zm15.159,-1.568c1.291,0.007 2.821,0.692 2.872,2.286c0.048,4.592 0.109,9.185 -0.001,13.776c-0.05,1.214 -1.035,2.22 -2.347,2.23l-7.32,0l0,-1.568c2.474,0 4.95,0.098 7.422,-0.002c0.375,-0.022 0.667,-0.278 0.678,-0.746c0.036,-4.562 0.145,-9.127 -0.001,-13.687c-0.034,-0.639 -1.307,-0.721 -1.307,-0.721l-2.611,0l0,-1.568l2.615,0z"
          />
          <path
            id="svg_9"
            d="m3.524,7.884l21.428,0l0,1.568l-21.428,0l0,-1.568zm7.317,-4.703l7.317,0l0,1.568l-7.317,0l0,-1.568z"
          />
          <text
            fontWeight="bold"
            textAnchor="start"
            fontFamily="Arial, sans-serif"
            fontSize="6"
            id="svg_20"
            y="15.350623"
            x="8.333934"
            fillOpacity="null"
            strokeOpacity="null"
            strokeWidth="0"
            stroke="null"
          >
            CSV
          </text>
        </g>
      </symbol>
    </svg>
  )
}
